<script context="module" lang="ts">
	let globalLabels: any

	export function setLabels(labels: any) {
		globalLabels = labels
	}
</script>

<script lang="ts">
	import { createEventDispatcher, getContext } from 'svelte'

	import RowsCountSelector from './RowsCountSelector.svelte'
	const dispatch = createEventDispatcher()
	const stateContext = getContext('state')

	export let useSelectPage = false
	export let buttons = [-2, -1, 0, 1, 2]
	export let count: any
	export let page = 0
	export let pageSize: any
	export let serverSide = false
	export let disabled = true

	let windowInnerWidth: number

	// export let labels = {
	//   first: "First",
	//   last: "Last",
	//   next: "Next",
	//   previous: "Previous",
	//   ...globalLabels
	// };
	export let labels = {
		first: '|<',
		last: '>|',
		next: '>',
		previous: '<',
		...globalLabels
	}

	$: pageCount = Math.floor(count / pageSize)

	$: {
		if (windowInnerWidth < 640) {
			labels = {
				first: '|<',
				last: '>|',
				next: '>',
				previous: '<',
				...globalLabels
			}
			useSelectPage = true
		} else {
			labels = {
				first: 'First',
				last: 'Last',
				next: 'Next',
				previous: 'Previous',
				...globalLabels
			}
			useSelectPage = false
		}
	}

	function onChange(event: any, page: number) {
		const state = stateContext.getState()
		// console.log('Pagination - onChange', page, state)

		const detail = {
			originalEvent: event,
			page,
			pageIndex: serverSide ? 0 : page * state.pageSize,
			pageSize: state.pageSize
		}
		dispatch('pageChange', detail)

		// if (detail.preventDefault !== true) {
		if (event.preventDefault !== true) {
			stateContext.setPage(detail.page, detail.pageIndex)
		}
	}

	function handlePageSizeChange(event: any) {
		console.log('PageSizeChanged:', event.detail.newPageSize)
		const newPageSize = event.detail.newPageSize
		const state = stateContext.getState()
		const detail = {
			originalEvent: event,
			page: state.page,
			pageIndex: serverSide ? 0 : state.page * newPageSize,
			pageSize: newPageSize
		}
		console.log('Dispatch pageSizeChange', detail)
		dispatch('pageSizeChange', detail)

		if (event.preventDefault !== true) {
			stateContext.setPageSize(detail.pageSize)
			// console.log('Pagination - onPageSizeChange - setPageSize', detail.pageSize)
		}
	}
</script>

<svelte:window bind:innerWidth={windowInnerWidth} />
<div class="h-9 table w-full">
	<div class="inline ml-0">
		<RowsCountSelector {pageSize} on:pageSizeChange={(e) => handlePageSizeChange(e)} />
	</div>
	<div class="float-right">
		<ul class="mr-0">
			<li>
				<button
					data-test-id="pagination_first"
					disabled={page === 0}
					on:click={(e) => onChange(e, 0)}
				>
					{labels.first}
				</button>
			</li>
			<li>
				<button
					data-test-id="pagination_previous"
					disabled={page === 0}
					on:click={(e) => onChange(e, page - 1)}
				>
					{labels.previous}
				</button>
			</li>
			{#if useSelectPage}
				<li>
					<div class="whitespace-nowrap max-w-min inline-flex align-middle mb-2">
						<select
							id="pageNumber"
							name="pageNumber"
							value={page.toString()}
							on:change={(e) => onChange(e, Number(e.currentTarget.value))}
						>
							{#each { length: pageCount + 1 } as _, i}
								<option value={i.toString()}>{i + 1}</option>
							{/each}
						</select>
					</div>
				</li>
			{:else}
				{#each buttons as button}
					{#if page + button >= 0 && page + button <= pageCount}
						<li>
							<button
								class:active={page === page + button}
								on:click={(e) => onChange(e, page + button)}
							>
								{page + button + 1}
							</button>
						</li>
					{/if}
				{/each}
			{/if}
			<li>
				<button
					data-test-id="pagination_next"
					disabled={page > pageCount - 1}
					on:click={(e) => onChange(e, page + 1)}
				>
					{labels.next}
				</button>
			</li>
			<li>
				<button
					data-test-id="pagination_last"
					disabled={page >= pageCount}
					on:click={(e) => onChange(e, pageCount)}
				>
					{labels.last}
				</button>
			</li>
		</ul>
	</div>
</div>

<style lang="postcss">
	.active {
		@apply bg-gray-100 text-black;
		/* background-color: rgb(150, 150, 235);
    color: white; */
	}

	ul {
		flex: 1;
		float: right;
		list-style: none;
	}

	li {
		float: left;
	}
	select {
		height: 36px;
		border-radius: 0.25rem;
		background: transparent;
		border: 1px solid #ccc;
		padding: 5px 10px;
		margin-left: 3px;
		float: left;
		cursor: pointer;
	}

	button {
		height: 36px;
		border-radius: 0.25rem;
		background: transparent;
		border: 1px solid #ccc;
		padding: 5px 10px;
		margin-left: 3px;
		float: left;
		cursor: pointer;
	}

	button:disabled {
		border: 1px solid #999;
		color: #999;
	}
</style>
